import { provide, inject } from 'vue';

const createContext = (id) => {
  const contextId = Symbol(id);
  const provider = (value) => provide(contextId, value);
  const consumer = (fallback) => inject(contextId, fallback);
  return [provider, consumer, contextId];
};

export { createContext };
